export default __webpack_public_path__ + "static/CLUB-10-66bd0c9d5dfc91e25b2c718379ce1a98.png";